import { render, staticRenderFns } from "./Checkbox.form-builder.vue?vue&type=template&id=2c482b71&"
import script from "./Checkbox.form-builder.vue?vue&type=script&lang=js&"
export * from "./Checkbox.form-builder.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports